.page { display: flex; flex-direction: column; gap: 14px; padding: 2px 0 24px; min-width: 0; }
.tabs { display: flex; align-items: center; justify-content: space-between; gap: 12px; min-width: 0; }
.chip { padding: 2px 8px; border-radius: 8px; background: var(--pri-bg); color: var(--link); font-size: 12px; font-weight: var(--fw-label); }
.live { font-size: 12px; color: var(--lb); }
.period { display: inline-flex; align-items: center; gap: 4px; }
.period button { display: inline-grid; place-items: center; width: 30px; height: 32px; border: 0; border-radius: 10px; background: transparent; color: var(--tx2); cursor: pointer; }
.period span { min-width: 100px; text-align: center; font-size: 13px; font-weight: var(--fw-label); }

.stats { display: grid; grid-template-columns: 1.15fr 1fr repeat(4, minmax(0, 0.9fr)); gap: 14px; }
.stat { padding: 14px 14px 12px; border-radius: 16px; background: var(--card); box-shadow: var(--sh); min-width: 0; }
.stat > div:first-child { color: var(--lb); font-size: 12px; }
.stat b { display: block; margin-top: 2px; font-size: 24px; font-weight: var(--fw-label); letter-spacing: -0.02em; }
.stat > div:last-child:not(:first-child) { color: var(--lb); font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.gA { color: var(--ok); }
.gB { color: var(--link); }
.gC { color: var(--warn); }
.gD { color: var(--err); }

.row { display: grid; grid-template-columns: minmax(0, 1fr) 404px; gap: 14px; align-items: start; }
.card { border-radius: 16px; background: var(--card); box-shadow: var(--sh); padding: 16px; overflow: clip; font-size: 13px; }
.cardHd { display: flex; align-items: baseline; gap: 12px; }
.cardHd h2 { margin: 0; font-size: 15px; font-weight: var(--fw-title); }
.cardHd span { color: var(--lb); font-size: 12px; }
.cardHd button { margin-left: auto; align-self: center; }

.legend { display: flex; align-items: center; gap: 14px; margin: 14px 0 8px; font-size: 12px; color: var(--tx2); }
.legend i { display: inline-block; width: 10px; height: 10px; margin-right: 6px; border-radius: 3px; vertical-align: -1px; }
.legend em { margin-left: auto; font-style: normal; color: var(--lb); }
.bars { position: relative; display: grid; grid-template-columns: repeat(7, 1fr); gap: 0; align-items: end; height: 168px; border-bottom: 1px solid var(--line); background: repeating-linear-gradient(to top, transparent 0 41px, var(--line) 41px 42px); }
.bar { width: 57px; justify-self: center; background: var(--d-blue); border-radius: 4px 4px 0 0; min-height: 2px; }
.avgLine { position: absolute; left: 0; right: 0; height: 2px; background: var(--warn); }
.xs { display: grid; grid-template-columns: repeat(7, 1fr); gap: 0; margin-top: 8px; text-align: center; font-size: 12px; color: var(--tx2); }

.donut { display: flex; align-items: center; gap: 18px; margin: 18px 0 14px 6px; }
.ring { position: relative; flex: none; width: 122px; height: 122px; border-radius: 50%; }
.ring::after { content: ''; position: absolute; inset: 16px; border-radius: 50%; background: var(--card); }
.grades { flex: 1; display: grid; grid-template-columns: 1fr auto auto; gap: 8px 14px; align-items: center; font-size: 13px; }
.grades i { display: inline-block; width: 8px; height: 8px; margin-right: 8px; border-radius: 50%; }
.grades b { text-align: right; font-weight: var(--fw-label); }
.grades span { text-align: right; color: var(--lb); font-size: 12px; min-width: 32px; }
.unscored { display: flex; align-items: center; gap: 10px; color: var(--tx2); }
.unscored span { font-size: 12px; color: var(--lb); }
.unscored b { margin-left: auto; font-weight: var(--fw-label); color: var(--tx); }

.gauges { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; margin-top: 14px; text-align: center; }
.gauge svg { display: block; margin: 0 auto; }
.gauge b { display: block; font-weight: var(--fw-label); }
.gauge div { font-size: 12px; color: var(--lb); }

.tbl { width: 100%; margin-top: 8px; table-layout: fixed; border-collapse: collapse; white-space: nowrap; }
.tbl th { height: 35px; padding: 0 10px; font-size: 12px; font-weight: var(--fw-label); color: var(--lb); text-align: left; border-bottom: 1px solid var(--line); }
.tbl td { height: 49px; padding: 0 10px; border-bottom: 1px solid var(--line); overflow: hidden; text-overflow: ellipsis; }
.tbl tr:last-child td { border-bottom: 0; }
.tbl .r { text-align: right; }
.tbl td.r b { font-weight: var(--fw-label); }
.mute { color: var(--lb); }
.real { color: var(--ok); }
.sample { color: var(--warn); }

@media (max-width: 1100px) {
  .stats { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .row { grid-template-columns: minmax(0, 1fr); }
  .gauges { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
